import { render } from "./addEmployee.vue?vue&type=template&id=3e1e2e6c&scoped=true"
import script from "./addEmployee.vue?vue&type=script&lang=js"
export * from "./addEmployee.vue?vue&type=script&lang=js"

import "./addEmployee.vue?vue&type=style&index=0&id=3e1e2e6c&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e1e2e6c"]])

export default __exports__